import { useMemo } from 'react';

import { useSession } from '@/components/auth';
import { apiService } from '@/services/api-service';

/**
 * The api-service methods, bound ONCE at module scope.
 *
 * These must keep a stable identity: consumers use them as effect dependencies
 * (`useAttachmentBlobs` depends on `downloadFile`). Re-binding per render made that
 * effect re-run on every render, with each run cancelling the previous one mid-
 * download — so blobs were re-fetched repeatedly and the loader could fail to
 * settle. `apiService` is a singleton, so binding once is safe.
 */
const boundApi = {
	fetchApi: apiService.fetchApi.bind(apiService),
	downloadFile: apiService.downloadFile.bind(apiService),
	uploadFileToServer: apiService.uploadFile.bind(apiService),
	searchAddress: apiService.searchAddress.bind(apiService),
};

export function useApi() {
	const { user } = useSession();

	// Memoized so the returned OBJECT is also stable while the user is unchanged —
	// callers that spread it into a dependency array get the same benefit.
	return useMemo(() => ({
		user,
		...boundApi,
		apiBaseUrl: apiService.getApiBaseUrl(),
	}), [user]);
}
